import React from 'react';
import { inject, observer } from 'mobx-react';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import '../../styles/components/Modal.css';

Modal.setAppElement('#root');

export default inject('filterStore')(
  observer(class SettingsModal extends React.Component {
    constructor() {
      super();
      this.closeModal = this.closeModal.bind(this);
      this.toggleOnLeave = this.toggleOnLeave.bind(this);
    }

    closeModal() {
      this.props.filterStore.toggleModal(false);
    }

    toggleOnLeave(e) {
      this.props.filterStore.toggleOnLeave(e.currentTarget.checked);
    }

    render() {
      return (
        <div className=''>
          <Modal
            isOpen={this.props.filterStore.settingsIsOpen}
            contentLabel="Instellingen modal"
            onRequestClose={() => {
              this.closeModal();
            }}
          >
            <div className="modal-head">
              <div className="modal-head__title">
                Instellingen
              </div>

              <div className="modal-buttons">
                <button className="btn btn--white modal__close" onClick={this.closeModal}>
                  <FontAwesomeIcon icon="times" /> Sluit
                </button>
              </div>
            </div>

            <label htmlFor="leave-toggle">
              <input
                type="checkbox"
                id="leave-toggle"
                onChange={this.toggleOnLeave}
                checked={this.props.filterStore.showOnLeave}
              />
              Toon afwezig?
            </label>
          </Modal>
        </div>
      );
    }
  })
);



// WEBPACK FOOTER //
// ./src/components/FilterBar/SettingsModal.js